enum OrderOptimizerCargoListingFilterType {
  ORDER_HUMAN_ID = "ORDER_HUMAN_ID",
}

export default OrderOptimizerCargoListingFilterType;
